const target = document.querySelector( ".js-sticky-menu" );
const limit = 160;
let scrollPosition = 0;
let ticking = false;
if (target)
  {window.addEventListener('scroll', (e) => {
    scrollPosition = window.scrollY;
    if(!ticking) {
      window.requestAnimationFrame(() => {
        if (limit < scrollPosition) {
          target.classList.add('sticky-on');
        } else {
          target.classList.remove('sticky-on');
        }
        ticking = false;
      });
    }
    ticking = true;
  });
}